import React, { useState, useEffect } from "react";
import Parser from "html-react-parser";
// import Select from "react-select";
import GUI_Header from "./gui/GUI_Header";
import GUI_Credit from "./gui/GUI_Credit";
import GUI_Input2TextAreas from "./gui/GUI_Input2TextAreas";
import GUI_Select from "./gui/GUI_Select";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
import T from "./TheTool";
import S from "./TheStats";
import H from "./TheHTML";
import TG from "./TextGen";

// import Timer from "./TheTimer";
import wilcoxon from "./stats/wilcoxon";
import mannwhitneyu from "./stats/mannwhitneyu";
// import {ShapiroWilkW, pvalue_sw} from "./stats/shapiro";
// import { ttest } from "@stdlib/stats-ttest";
// import "@stdlib/stats-ttest";//not work
// import random from "stdlib";

//https://github.com/stdlib-js/stdlib
//https://github.com/pieterprovoost/jerzy
//https://dev.to/jjude/descriptive-analytics-in-javascript
//https://www.npmjs.com/package/simple-statistics
//https://www.gungorbudak.com/blog/2016/01/16/mann-whitney-u-test-wilcoxon-rank-sum-test-javascript/
//https://gist.github.com/gungorbudak/1c3989cc26b9567c6e50

const TwoSamples = () => {
	useEffect(() => {
		document.title = "Two sample test";
	}, []);
	const [guiTxtArea, guiTxtAreaChange] = useState("45\n45\n45\n50\n55\n80");
	const [guiTxtArea2, guiTxtArea2Change] = useState("62\n55\n55\n65\n68\n70");

	//--------------------
	const [selectedOption, setSelectedOption] = useState({
		value: "1",
		label: "Paired Samples",
	});
	const selecter_option = [
		{ value: "1", label: "Paired Samples" },
		{ value: "2", label: "Independent Samples" },
	];
	function selection_handle(e) {
		console.log("xxx" + e.value);
		setSelectedOption(e);
	}
	//--------------------

	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		process();
	};

	// function process() {
	// 	let m = selectedOption.value;
	// 	// console.log("xxx" + m);
	// 	if (m == "1") {
	// 		console.log("Paired Samples");
	// 		process_pairTest();
	// 	} else {
	// 		console.log("Independent Samples");
	// 		process_indeTest();
	// 	}
	// }

	function process() {
		let typeoftest = selectedOption.value;
		let output_html = "";
		let testname_para =
			typeoftest == "1"
				? "Paired Samples t-Test"
				: "Independent Samples t-Test";
		let testname_nonpara =
			typeoftest == "1"
				? "Wilcoxon Signed-Rank Test"
				: "Mann–Whitney U Test or Kolmogorov-Smirnov Test";
		let data; //data for table
		let w; //width for table
		let t; //tale
		let jv1, jv2; //vector data of arr
		let out, out1, out2; //output
		let txt, txt1, txt2, txt3; //text
		let mean1, mean2; //mean, double
		let sd1, sd2; //sd, double
		let arr;
		let b, b1, b2; //boolean
		let n; //int
		let arrD; //difference between pair
		let jvD; //vector data of arrD
		//Data ===================================================================
		var arr1 = T.str_LinestoListInt(guiTxtArea, false);
		var arr2 = T.str_LinestoListInt(guiTxtArea2, false);
		//prepare tool ===========================================================
		var descstat = require("simple-statistics");
		var ttest = require("@stdlib/stats-ttest");
		var jerzy = require("jerzy");
		var leveneTest = require("@stdlib/stats-levene-test");
		var ttest2 = require("@stdlib/stats-ttest2");
		jv1 = new jerzy.Vector(arr1);
		jv2 = new jerzy.Vector(arr2);
		//Descriptive Statistics =================================================
		mean1 = descstat.mean(arr1);
		mean2 = descstat.mean(arr2);
		sd1 = descstat.standardDeviation(arr1);
		sd2 = descstat.standardDeviation(arr2);
		//PRINE RESULT --------
		output_html += "<h2>Descriptive Statistics</h2>";
		output_html += "<br/>";
		data = [
			["", "Sample 1", "Sample 2"],
			["Mean", mean1, mean2],
			["Median", descstat.median(arr1), descstat.median(arr2)],
			["Mode", descstat.mode(arr1), descstat.mode(arr2)],
			["SD", sd1, sd2],
			["Min", descstat.min(arr1), descstat.min(arr2)],
			["Man", descstat.max(arr1), descstat.max(arr2)],
			["N", arr1.length, arr2.length],
		];
		w = ["auto", "auto", "auto"];
		output_html += H.makeTable(data, w, false);
		output_html += "<hr/>";
		//Normality Test ===========================================================
		out1 = jerzy.Normality.shapiroWilk(jv1);
		out2 = jerzy.Normality.shapiroWilk(jv2);
		//PRINT CONSOLE -------
		T.log_obj2("SW1 ", out1, ""); //console.log("SW1 " + JSON.stringify(out1, null, 4));
		T.log_obj2("SW2 ", out2, ""); //console.log("SW2 " + JSON.stringify(out2, null, 4));
		//PRINT GUI --------
		output_html += "<h2>Normality Test (Shapiro–Wilk Test)</h2><br/>";
		// data = [['','W','p-value'],['Sample 1',out1.w,out1.p],['Sample 2',out2.w,out2.p]];
		data = [
			["", "Sample 1", "Sample 2"],
			// ["p-value", out1.p, out2.p],
			// ["W", out1.w, out2.w],
            ["p-value", T.roundToFix(out1.p, 5), T.roundToFix(out2.p,5)],
			["W", T.roundToFix(out1.w, 5), T.roundToFix(out2.w, 5)],
		];
		w = ["auto", "auto", "auto"];
		output_html += H.makeTable(data, w, false);
		b1 = out1.p < 0.05; // ? true : false;
		b2 = out2.p < 0.05; // ? true : false;
		arr = [];
		arr.push(TG.txt_normalDistribution("Sample 1", b1));
		arr.push(TG.txt_normalDistribution("Sample 2", b2));
		n = T.arr_countTrue([b1, b2]);
		arr.push(TG.txt_normalityTest(2, n, testname_para, testname_nonpara));
		if (typeoftest == "1") {
			arr.push(
				"You may also consider an alternative normality test (on difference data) below."
			);
		}
		output_html += H.makeBullet(arr);
		output_html += "<hr/>";
		//split paired and independent ===============================================================
		if (typeoftest == "1") {
			console.log("Paired Samples");
			arrD = T.arr_getDiff(arr1, arr2);
			jvD = new jerzy.Vector(arrD);
			//Check ===========================================================
			if (arr1.length != arr2.length) {
				txt1 = TG.txt_differentN(arr1, arr2);
				BuildResult(txt1);
				return;
			}
			//Normality Test ===========================================================
			out = jerzy.Normality.shapiroWilk(jvD);
			//PRINT GUI --------
			output_html += "<h2>Normality Test 2 (Shapiro–Wilk Test)</h2>";
			output_html += "<br/>";
			data = [
				["", "Difference (Sample 2 - Sample 1)"],
				["p-value", out.p],
				["W", out.w],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			n = out.p < 0.05 ? 1 : 0;
			txt = TG.txt_normalityTest(1, n, testname_para, testname_nonpara);
			output_html += H.makeBullet([txt]);
			output_html += "<hr/>";
			//paired t-Test ===========================================================
			out = ttest(arr1, arr2);
			//PRINT CONSOLE -------
			T.log_obj2("ttest ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Paired Sample t-Test (Parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.pValue + " (" + out.alternative + ")"],
				["t", out.statistic],
				["ci", out.ci[0]],
				["", out.ci[1]],
				["df", out.df],
				// ["# of null", out.nullValue],
				["mean", out.mean],
				["sd", out.sd],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			txt1 = TG.txt_ttest_sig(
				out.pValue < 0.05,
				T.roundToTwo(mean1),
				T.roundToTwo(sd1),
				T.roundToTwo(mean2),
				T.roundToTwo(sd2),
				"95%"
			);
			output_html += H.makeBullet([txt1]);
			output_html += "<hr/>";
			//Wilcoxon ===========================================================
			out = wilcoxon(arr1, arr2);
			//PRINT CONSOLE -------
			T.log_obj2("wc ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Wilcoxon Signed-Rank Test (Non-parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.P],
				["W", out.W],
				["", out.Warning],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			txt1 = TG.txt_sig(out.P < 0.05, "95%");
			arr = [txt1];
			if (arr1.length < 5) {
				arr.push(TG.txt_n_toofew("5 pairs")); //arr.push("The data has < 5 pairs, reliable result cannot be acheived.");
			} else if (arr1.length < 20) {
				arr.push(TG.txt_n_suggest("20 pairs")); //arr.push("It is suggested to has at least 20 pairs of data for reliable results."
			}
			output_html += H.makeBullet(arr);
			output_html += "<hr/>";
		} else {
			console.log("Independent Samples");
			//Levene's test for Homogeneity of Variance ===========================================================
			out = leveneTest(arr1, arr2);
			//PRINT CONSOLE -------
			T.log_obj2("lv ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Levene's test for Homogeneity of Variance (for t-Test)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.pValue],
				["F", out.statistic],
				["df", out.df],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);

			if (out.P < 0.05) {
				arr = [
					"Variance of the two samples are considered unequal.",
					"See Independent Samples t-Test: Unequal Variance",
				];
			} else {
				arr = [
					"Variance of the two samples are considered equal.",
					"See Independent Samples t-Test: Equal Variance",
				];
			}
			output_html += H.makeBullet(arr);
			output_html += "<hr/>";
			//T-test ===========================================================
			out = ttest2(arr1, arr2, { variance: "equal" });
			T.log_obj2("T Eq ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Independent Samples t-Test: Equal Variance (Parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.pValue + " (" + out.alternative + ")"],
				["t", out.statistic],
				["ci", out.ci[0]],
				["", out.ci[1]],
				["df", out.df],
				// ["# of null", out.nullValue],
				["xmean", out.xmean],
				["ymean", out.ymean],
				["method", out.method],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			txt1 = TG.txt_ttest_sig(
				out.pValue < 0.05,
				T.roundToTwo(mean1),
				T.roundToTwo(sd1),
				T.roundToTwo(mean2),
				T.roundToTwo(sd2),
				"95%"
			);
			arr = [txt1];
			output_html += H.makeBullet(arr);
			output_html += "<hr/>";
			//T-test ===========================================================
			out = ttest2(arr1, arr2, { variance: "unequal" });
			T.log_obj2("T Eq ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Independent Samples t-Test: Unequal Variance (Parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.pValue + " (" + out.alternative + ")"],
				["t", out.statistic],
				["ci", out.ci[0]],
				["", out.ci[1]],
				["df", out.df],
				// ["# of null", out.nullValue],
				["xmean", out.xmean],
				["ymean", out.ymean],
				["method", out.method],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			txt1 = TG.txt_ttest_sig(
				out.pValue < 0.05,
				T.roundToTwo(mean1),
				T.roundToTwo(sd1),
				T.roundToTwo(mean2),
				T.roundToTwo(sd2),
				"95%"
			);
			arr = [txt1];
			output_html += H.makeBullet(arr);
			output_html += "<hr/>";
			//Mann–Whitney U Test ===========================================================
			out = mannwhitneyu.test(arr1, arr2);
			//PRINT CONSOLE -------
			T.log_obj2("U ", out, "");
			//PRINT GUI -------
			output_html += "<h2>Mann-Whitney U Test (Non-parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.p],
				["U", out.U],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			// txt1 = TG.txt_sig(out.p < 0.05, "95%");
			// arr = [txt1];
			// output_html += H.makeBullet(arr);
            if (out.p < 0.05) {
				txt1 = "The probability of Sample 1 being greater than Sample 2 is not equal to the probability of sample 2 being greater than sample 1.";
                txt2 = "There is a significant difference between Sample 1 and Sample 2 at 95% Confident Interval.";
			} else {
				txt1 = "The probability of Sample 1 being greater than Sample 2 is equal to the probability of sample 2 being greater than sample 1. ";
				txt2 = "There is no significant difference between Sample 1 and Sample 2 at 95% Confident Interval.";
			}
            txt = "You may also consider an alternative result from Kolmogorov-Smirnov Test";
			output_html += H.makeBullet([txt1, txt2, txt]);
			output_html += "<hr/>";
            //The approximation to the form of the normal distribution becomes less robust at sample sizes smaller than 10
			//Distribution Test Kolmogorov Smirnov ===========================================================
			out = new jerzy.Nonparametric.kolmogorovSmirnov(jv1, jv2);
			//PRINT CONSOLE -------
			T.log_obj2("KS ", out, ""); //console.log("SW1 " + JSON.stringify(out1, null, 4));
			//
			output_html += "<h2>Kolmogorov-Smirnov Test (Non-parametric)</h2>";
			output_html += "<br/>";
			data = [
				["p-value", out.p],
				["d", out.d],
				["ks", out.ks],
			];
			w = ["auto", "auto"];
			output_html += H.makeTable(data, w, false);
			if (out.p < 0.05) {
				txt1 = "Two samples come from different distribution.";
                txt2 = "There is a significant difference between Sample 1 and Sample 2 at 95% Confident Interval.";
			} else {
				txt1 = "Two samples come from the same distribution";
				txt2 = "There is no significant difference between Sample 1 and Sample 2 at 95% Confident Interval.";
			}
			output_html += H.makeBullet([txt1, txt2]);
			output_html += "<hr/>";
			//-----------

			BuildResult("The remaining part is under development");
		}
		//---------
		BuildResult(output_html);
	}

	function wwwwait() {
		// out1 = ttest(arr1, { mu: 0 });
		// console.log(
		// 	"ccc1 " + out1.pValue + " ___ " + out1.statistic + " ___ " + out1.ci
		// );
		// //---------
		// out2 = ttest(arr1, { mu: m2 });
		// console.log(
		// 	"ccc2 " + out2.pValue + " ___ " + out2.statistic + " ___ " + out2.ci
		// );
		// //---------
		// let n = arr1.length;
		// let m = arr2.length;
		// var out4 = S.tTest(arr1, n, arr2, m);
		// console.log("ccc4 " + out4);
	}

	//-------------------------

	function BuildResult(output_html) {
		partResultChange(
			<div>
				<br />
				<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
					<h2>Results</h2>
				</div>
				<div className="content">{Parser(output_html)}</div>
			</div>
		);
	}

	function printDetail() {
		let t = H.makeBullet([
			"Normality Tests: <b>Shapiro–Wilk</b> Test",
            "Test for Homogeneity of Variance: <b>Levene's</b> Test",
			"Paired Samples Tests: Paired Samples <b>t-Test</b>, <b>Wilcoxon</b> Signed-Rank Test",
			"Independent Samples Tests: Independent Samples <b>t-Test</b>, <b>Mann–Whitney</b> U Test, </br><b>Kolmogorov-Smirnov</b> Test",
        ]);
		return (
			<div>
				<b>List of tests </b>
				{Parser(t)}
			</div>
		);
	}
	//--------------------------------------------------------

	return (
		<div className="todoapp stack-large">
			<GUI_Header
				title={"2-Sample Tests"}
				desc={
					"Two-sample test is a test performed on the data of two random samples, each independently obtained from a different given population. The purpose of the test is to determine whether the difference between these two populations is statistically significant."
				}
			/>
			{printDetail()}
			{/* <div style={{ marginTop: "3em" }}> </div> */}
			<GUI_Input2TextAreas
				id="inputItemList"
				className="textarea_001"
				placeholder={"name,size,value"}
				// placeholder={"name,weight,value\nname,weight,value\nname,weight,value"}
				// style={{ minHeight: "308px", whiteSpace: "pre-line" , fontSize: 28  }}
				// style={{ minHeight: "308px", whiteSpace: "pre-line" }}
				// defaultValue={txtDefault}
				// defaultValue="A,12,4B,4,10 C,2,2 D,1,2 E,1,1"
				// value={guiTxtArea}
				// onChange={guiTxtAreaChange}
				area1Change={guiTxtAreaChange}
				text1={guiTxtArea}
				area2Change={guiTxtArea2Change}
				text2={guiTxtArea2}
				label={"Sample 1"}
				label2={"Sample 2"}
			/>
			<GUI_Select
				label={"Type"}
				width1={100}
				selecter_option={selecter_option}
				selectedOption={selectedOption}
				setSelectedOption={selection_handle}
			/>
			{/* 
			<Select
				id="selectMode"
				name="selectMode"
				options={selecter_option}
				// value={selecter_v}
				// onChange={handleChange}
				// defaultValue={{ value: "1", label: "Kanji-EN" }}
				defaultValue={selectedOption}
				onChange={setSelectedOption}
			/> */}
			<div style={{ display: "flex", marginLeft: "3%", marginRight: "3%" }}>
				<button
					onClick={() => buttonClick1()}
					className="btn btn__primary btn__lg"
					style={{ flex: 1, height: 50 }}
				>
					Calculate
				</button>
			</div>
			{partResult}
			<GUI_Credit />
		</div>
	);
};

export default TwoSamples;
